
import config from 'common/config'
import axios from 'axios'
axios.defaults.withCredentials = true
axios.defaults.transformRequest = [function (data) {
    let objLeb = data == undefined ? 0 : Object.keys(data).length
    let ret = '', i = 0
    for (let it in data) {
        ret += encodeURIComponent(it) + '=' + encodeURIComponent(data[it])
        i = i + 1
        if (i < objLeb) {
            ret += '&'
        }
    }
    return ret
}]
var instance = axios.create({/*application/json*/
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
});
/*
axios.defaults.timeout =  5000;
*/
axios.interceptors.response.use(function (response) {
    return response;
}, function (error) {
    return Promise.reject(error);
});
/*axios.defaults.retry = 1;
axios.defaults.retryDelay = 500;
axios.interceptors.response.use(undefined, function axiosRetryInterceptor(err) {
  var config = err.config;
  // If config does not exist or the retry option is not set, reject
  if(!config || !config.retry) return Promise.reject(err);
  // Set the variable for keeping track of the retry count
  config.__retryCount = config.__retryCount || 0;
  // Check if we've maxed out the total number of retries
  if(config.__retryCount >= config.retry) {
    // Reject with the error
    return Promise.reject(err);
  }
  // Increase the retry count
  config.__retryCount += 1;
  // Create new promise to handle exponential backoff
  var backoff = new Promise(function(resolve) {
    setTimeout(function() {
      resolve({timeout: true});
    }, config.retryDelay || 1);
  });
  // Return the promise in which recalls axios to retry the request
  return backoff.then(function() {
    return axios(config);
  });
});*/

const MyPlugin = {
    install: function (Vue, options) {
        // 判断属性值是否为空 并赋值
        Vue.prototype.isEmpty = function (obj, value) {
            for (let i in obj) {
                if (obj[i] === '' || obj[i] == null) {
                    obj[i] = value
                }
            }
            return obj
        }
        // 判断属性值是否为空 并赋值
        Vue.prototype.emptiness = function (str) {
            if (str == null || str == undefined || str == '') {
                return ''
            } else {
                return str
            }
        }
        Vue.prototype.scrollYauto = function () {
            document.documentElement.style.overflowY = 'auto'
        }
        Vue.prototype.scrollYhidden = function () {
            document.documentElement.style.overflowY = 'hidden'
        }
        // 置空对象属性
        Vue.prototype.emptyObj = function (obj) {
            for (let i in obj) {
                obj[i] = ''
            }
            return obj
        }
        //getcookie 获取
        Vue.prototype.getcookie = function (objname) {
            //获取指定名称的cookie的值
            var arrstr = document.cookie.split("; ");
            for (var i = 0; i < arrstr.length; i++) {
                var temp = arrstr[i].split("=");
                if (temp[0] == objname) {
                    return unescape(temp[1]);
                }
            }
        }

        //回调函数 判断是否为空数据
        Vue.prototype.isNull = function (param) { //数据类型有 Number String {} [] boolean '' null undefined
            let _flag = true;
            if ((typeof param) != 'object' || param == null) {
                if (param == null) {
                    _flag = false;
                    return _flag
                } else if (param == '') {
                    _flag = false;
                    return _flag
                } else if (param == undefined) {
                    _flag = false;
                    return _flag
                } else {
                    return _flag
                }
            } else if ((typeof param) == 'object') {
                if (param instanceof Array) {
                    _flag = param.length > 0 ? true : false
                    return _flag
                } else if (param instanceof Object) {
                    _flag = Object.keys(param).length > 0 ? true : false
                    return _flag
                }
            }
        }

        // 时间戳转换日期
        Vue.prototype.format = function (timestamp, stime) {
            timestamp = timestamp + '';
            let Y, M, D, h, m, s;
            let date;
            if (timestamp.length < 11) {
                date = new Date(timestamp * 1000);
            } else {
                date = new Date(timestamp * 1);
            }
            //时间戳为10位需*1000，时间戳为13位的话不需乘1000
            Y = date.getFullYear() + '-';
            M =
                (date.getMonth() + 1 < 10
                    ? '0' + (date.getMonth() + 1)
                    : date.getMonth() + 1) + '-';
            D =
                (date.getDate() < 10 ? '0' + date.getDate() : date.getDate()) +
                ' ';
            h =
                (date.getHours() < 10 ? '0' + date.getHours() : date.getHours()) +
                ':';
            m = (date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()) +
                ':';
            s = (date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds());
            if (
                timestamp == '' ||
                timestamp == 0 ||
                timestamp == undefined ||
                timestamp == null
            ) {
                return '';
            } else {
                if (stime == 'miao') {
                    return Y + M + D + h + m + s;
                } else {
                    return Y + M + D;
                }
            }
            // return Y+M+D+h+m+s;  时分秒
        }

        // 获取当前 时间  年月日 星期几 时分秒
        Vue.prototype.allTime = function (times) {
            //定义一个日期对象;
            var dateTime = new Date(times);
            //获得系统年份;
            var year = dateTime.getFullYear();
            //获得系统月份;
            var month = dateTime.getMonth() + 1;
            //获得系统当月分天数;
            var day = dateTime.getDate();
            //获得系统小时;
            var hours = dateTime.getHours();
            //获得系统分钟;
            var minutes = dateTime.getMinutes();
            //获得系统秒数;
            var second = dateTime.getSeconds();
            //获得系统星期几;
            var dayCycle = dateTime.getDay();
            //使用数组更改日期样式;
            var dayCycleArray = ["日", "一", "二", "三", "四", "五", "六"];
            for (var i = 0; i < 7; i++) {
                if (dayCycle == i) {
                    //将dayCycleArray的数赋值到系统星期几里面中去;
                    dayCycle = dayCycleArray[i];
                }
            }
            month < 10 ? month = '0' + month : month;
            hours < 10 ? hours = '0' + hours : hours;
            minutes < 10 ? minutes = '0' + minutes : minutes;
            second < 10 ? second = '0' + second : second;
            //打印完整的系统日期;
            // let dateStr = year + '-' + month + '-' + day + ' ' + '星期' + dayCycle + ' ' + hours + ':' + minutes + ':' + second;
            let dateStr = year + '年' + month + '月' + day + '日/' + '星期' + dayCycle;
            return dateStr;
        },

            // 处理日期
            Vue.prototype.dealTime = function (obj) {
                let query = {}
                if (obj.startTime !== '') {
                    let start = new Date(obj.startTime)
                    start = `${start.getFullYear()}-${this.dealNums(start.getMonth() + 1)}-${this.dealNums(start.getDate())}`
                    query.startTime = `${start}`
                }
                if (obj.endTime !== '') {
                    let end = new Date(obj.endTime)
                    end = `${end.getFullYear()}-${this.dealNums(end.getMonth() + 1)}-${this.dealNums(end.getDate())}`
                    query.endTime = `${end}`
                }
                return query
            }
        Vue.prototype.dealNums = function (num) {
            num = parseInt(num) < 10 ? "0" + num : num
            return num
        }
        Vue.prototype.$http = axios
        // 处理url
        Vue.prototype.getUrl = function (url) {
            let getUrl = config.mockUrl + url
            return getUrl
        }
        Vue.prototype.goClose = function () {
            /* window.history.go(-1) */
            window.close()
        }
        Vue.prototype.goBack = function () {
            /* window.history.go(-1) */
            this.$router.back(-1)
        }
        Vue.prototype.freshPage = function () {
            /* window.history.go(-1) */
            location.reload()
        }
        Vue.prototype.messageBox = function (info, type, myCustomClass) {
            this.$message({
                message: info,
                type: type,
                duration: 1000,
                showClose: true,
                customClass: myCustomClass === undefined ? 'my-el-message' : myCustomClass
            })
        }
        Vue.prototype.loginFailure = function (file) {
            this.messageBox('登录失效，请重新登录', 'error')
            let t = null
            clearTimeout(t)
            t = setTimeout(() => {
                /*  this.$router.push('/login')
                  location.reload() // 主要是重新注入路由实例 */
                if (this.getcookie('psd_flag') == 'true') { // 下次登录再次提示
                    document.cookie = "psd_sort=true";
                }
                // window.open(`${this.$store.state.userInfo.logouturl}login`, '_self')
                let logouturl = this.$store.state.userInfo.logouturl ? this.$store.state.userInfo.logouturl : localStorage.getItem('logouturl')
                window.open(`${logouturl}login`, '_self')
            }, 1000)
        }
        // 处理返回数据 handle 为true时，组件自己处理返回数据
        Vue.prototype.handelResponse = function (res, cb, handle) {
            let _handle;
            if (handle == true) {
                _handle = true;
            }
            if (this.isNull(handle)) {
                if (handle.flag == true) {
                    _handle = true;
                }
            }
            // let _handle = this.isNull(handle) == true ? true : false;
            // debugger
            if (this.btn) {
                let that = this;
                let t = null;
                clearTimeout(t)
                t = setTimeout(() => {
                    that.btnClick();
                }, 500) // 按钮恢复可点击
            }
            if (res.status == '2') { // 半小时不操作，返回登录页
                this.loginFailure()
            }
            else if (res.status == '100') {
                this.messageBox(res.error[0], 'error')
                setTimeout(() => {
                    this.$router.push({ name: 'dataIndex' })
                })
            }
            else if (res.status == '0' || _handle == true) {
                cb(res)
            } else if (res.status == '1') {
                this.messageBox(res.error[0], 'error')
            }
        }
        // 处理文件上传返回 数据
        Vue.prototype.handleFileResonse = function (res) {
            return new Promise((resolve, reject) => {
                this.handelResponse(res, resolve)
            })
        }
        // 文件上传 通讯失败
        Vue.prototype.handleFileError = function () {
            this.messageBox('系统繁忙，请稍后再试', 'error')
        }
        Vue.prototype.apiGet = function (url, data) {
            return new Promise((resolve, reject) => {
                this.$http.get(this.getUrl(url), { params: data }).then((response) => {
                    this.handelResponse(response.data, resolve, data)
                }).catch((response) => { /*  reject(response) */
                    this.messageBox('系统繁忙，请稍后再试', 'error')
                })
            })
        }
        Vue.prototype.apiPost = function (url, data, config) {
            return new Promise((resolve, reject) => {
                this.$http.post(this.getUrl(url), this.emptiness(data, ""), config).then((response) => {
                    this.handelResponse(response.data, resolve, config);
                }).catch((response) => { /*  reject(response) */
                    if (this.btn) {
                        let that = this;
                        let t = null;
                        clearTimeout(t)
                        t = setTimeout(() => {
                            that.btnClick();
                        }, 500) // 按钮恢复可点击
                    }
                    if (config != undefined && config.back) {
                        resolve({ back: true })
                        return false
                    }
                    if (response.message.indexOf('timeout') != -1) {
                        this.messageBox(`操作成功`, 'success')
                    } else {
                        this.messageBox(`系统繁忙，请稍后再试`, 'error')
                    }
                })
            })
        }
    }
}
export default MyPlugin



// WEBPACK FOOTER //
// ./src/jvsit/common/http.js